module.exports = __webpack_public_path__ + "img/finddata.51132b84.png";